import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import translate from "@insite/client-framework/Translate";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import ShareIcon from "@NA/Icons/ShareIcon";
import shareProduct from "@NA/Overrides/Store/CommonHandlers/ShareProduct";
import ADIColors from "@NA/Utils/ADIColors";
import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    extendedStyles?: ADIProductShareLinkStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProduct;

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

const mapDispatchToProps = {
    shareProduct,
    //validateReCaptcha: makeHandlerChainAwaitable<any, boolean>(validateReCaptcha),    
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> },
        boolean
    >(validateReCaptcha),
    toggleLoginDrawer
};

export interface ADIProductShareLinkStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    recipientNameGridItem?: GridItemProps;
    recipientNameTextField?: TextFieldProps;
    recipientEmailGridItem?: GridItemProps;
    recipientEmailTextField?: TextFieldProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    yourEmailGridItem?: GridItemProps;
    yourEmailTextField?: TextFieldProps;
    yourMessageGridItem?: GridItemProps;
    yourMessageTextArea?: TextAreaProps;
    reCaptchaGridItem?: GridItemProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    shareButton?: ButtonPresentationProps;
    shareText?: InjectableCss;
    requiredFields?: InjectableCss;
}

export const adiProductShareLinkStyles: ADIProductShareLinkStyles = {
    link: {
        typographyProps: {
            css: css`
                >${IconWrapper}{
                    svg{
                        width: 18px;
                        height: 22px;
                    }
                }
            `
        }
    },
    modal: {
        size: 600,
        cssOverrides: {
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        border-radius: 7px;
                        box-shadow: 0 1px 9px 0 rgba(0, 0, 0, .14);
                        background-color: #fff;
                        position: absolute;
                        max-width: 356px !important;
                        height: fit-content;
                        top: 66px;
                        padding: 15px 10px 28px 10px;
                        overflow-x:hidden;
                    `,
                        css`
                        border-radius: 7px;
                        box-shadow: 0 1px 9px 0 rgba(0, 0, 0, .14);
                        background-color: #fff;
                        position: absolute;
                        max-width: 356px !important;
                        height: fit-content;
                        top: 66px;
                        padding: 15px 10px 28px 10px;
                        overflow-x:hidden;
                    `,
                        css`
                        max-width: 548px;
                        height: auto;
                    `,
                        css`
                        border-radius: 10px;
                        max-width: 548px;
                    `,
                        css`
                        border-radius: 10px;
                        max-width:548px;
                    `,
                    ])}
            `,
            modalTitle: css`
                padding: 24px 32px 0px 28px;
                border-bottom: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px;
                            font-size: 24px;
                            margin-bottom: 0px;
                        `,
                        css`
                            padding: 0px;
                            font-size: 24px;
                            margin-bottom: 0px;
                        `,
                        null,
                        null,
                        null,
                    ])}
                > ${ButtonWrapper} {
                    position: relative;
                    left: 30px;
                    bottom: 20px;
                     ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           left: 20px;
                           bottom: 20px;
                        `,
                        css`
                            left: 20px;
                            bottom: 20px;           
                        `,
                        null,
                        null,
                        null,
                    ])}

                    :hover{
                        background: none;
                        border-color: transparent;
                    }
                    > ${IconWrapper}{
                        height: 45px;
                        width: 45px;
                        color: ${getColor("primary")};
                        
                        > svg {
                            height: 35px;
                            width: 35px; 
                            stroke-width: 1.4;
                        }
                    }
                }
                > ${TypographyStyle} {
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 1.08;
                    margin-bottom: 10px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                                font-size: 24px;
                                margin-bottom: 0px;
                            `,
                        css`
                                font-size: 24px;
                                margin-bottom: 0px;
                            `,
                        null,
                        null,
                        null,
                    ])}
                }
            `,

            modalContent: css`
                padding: 20px 30px;
                padding-top: 0px;
                padding-bottom: 28px;
                margin-top: -10px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px;
                        `,
                        css`
                            padding: 0px;
                        `,
                        null,
                        null,
                        null,
                    ])}

            `,
        },

    },
    container: {
        gap: 10,
        css: css`    
            padding-top: 10px;

    ` },
    recipientNameGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    shareText: {
        css: css`
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.5;
        letter-spacing: normal;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size:12px;
                    line-height: normal;
                    color:#000;
                `,
                    css`
                    font-size:12px;
                    line-height:normal;
                    color: #000;
                `,
                    null,
                    null,
                    null,
                ])}

        `,
    },
    requiredFields: {
        css: css`
                font-size: 14px;
                color: ${ADIColors.darkBlack3};
            `,
    },
    recipientEmailGridItem: {
        width: 12,
        css: css`
            padding-left: 10px;
        `,
    },
    yourNameGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    yourEmailGridItem: {
        width: 12,
        css: css`
            padding-left: 10px;
            > ${FormFieldStyle} {
                flex-direction: row;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` flex-direction: column; `,], "max",);
            }}
                > label {
                    width: 25%;
                    text-align: right;
                    margin: auto;
                    padding-right: 12px;
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` width: 100%; text-align: left; `,], "max",);
            }}
                }
                > ${FormInputWrapper} {
                    width: 75%;
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` width: 100%; `,], "max",);
            }}
                }
            }
        `,
    },
    yourMessageGridItem: {
        width: 12,
        css: css`
        padding-left: 10px;    
    `,
    },
    yourMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
                height: 143px;
            `,
        },
    },
    reCaptchaGridItem: {
        width: 12,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 25px;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
        css: css`
         border-width: 1px;
        `,
    },
    shareButton: {
        css: css`
            margin-left: 20px;
            border-radius:0px;
            &:disabled {
                            background:${ADIColors.blue5};
                        }
        `,
    },
};


const ADIProductShareLink = ({
    product,
    productInfo,
    text,
    session,
    shareProduct,
    validateReCaptcha,
    extendedStyles,
    toggleLoginDrawer
}: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(adiProductShareLinkStyles, extendedStyles));
    const isAuthenticated = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [recipientName, setRecipientName] = React.useState("");
    const [recipientEmail, setRecipientEmail] = React.useState("");
    const [recipientEmailError, setRecipientEmailError] = React.useState("");
    const initialYourName = isAuthenticated
        ? `${session!.firstName} ${session!.lastName}`.trim() || session!.userName || ""
        : "";
    const [yourName, setYourName] = React.useState(initialYourName);
    const [yourNameError, setYourNameError] = React.useState("");
    const initialYourEmail = isAuthenticated ? session.email || "" : "";
    const [yourEmail, setYourEmail] = React.useState(initialYourEmail);
    const [yourEmailError, setYourEmailError] = React.useState("");
    const [yourMessage, setYourMessage] = React.useState("");
    const [yourMessageError, setYourMessageError] = React.useState("");
    const [inProgress, setInProgress] = React.useState(false);
    const [showEmailSentModal, setshowEmailSentModal] = React.useState(false);
    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
    const modalCloseHandler = () => {
        setModalIsOpen(false);
        setTimeout(() => {
            setshowEmailSentModal(false);
        }, 1000);
    };

    const shareLinkClickHandler = () => {        
        handleShare();
    };

    const openEmailPopup = ()=>{
        const { isAuthenticated } = session;
        if (!isAuthenticated) {
            return toggleLoginDrawer({ loginDrawer: true })
        }
        resetFields();
        setModalIsOpen(true);
    }
    const handleShare = async () => {
        try {
            const currentUrl = window.location.href;
            if (navigator.share) {
                await navigator.share({
                    title: 'ADI',
                    url: currentUrl,
                });
            } else {
                openEmailPopup();
            }
        }
        catch (error) {
            console.error('Error sharing:', error);
        }
    };
    const requiredFieldMessage = translate("This is a required field");
    const emailFieldMessage = translate("Enter a valid email address");
    const checkForErrors = () => {
        const regexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

        const localRecipientEmailError = !recipientEmail
            ? requiredFieldMessage
            : regexp.test(recipientEmail)
                ? ""
                : emailFieldMessage;
        setRecipientEmailError(localRecipientEmailError);
        const localYourEmailError = !yourEmail ? requiredFieldMessage : regexp.test(yourEmail) ? "" : emailFieldMessage;
        setYourEmailError(localYourEmailError);

        return !!(
            localRecipientEmailError ||
            localYourEmailError
        );
    };

    const resetFields = () => {
        setRecipientName("");
        setRecipientEmail("");
        setRecipientEmailError("");
        setYourName(initialYourName);
        setYourNameError("");
        setYourEmail(initialYourEmail);
        setYourEmailError("");
        setYourMessage("");
        setYourMessageError("");
        setInProgress(false);
    };

    const recipientEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRecipientEmail(event.target.value);
        setRecipientEmailError(!event.target.value ? requiredFieldMessage : "");
    };
    const yourEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setYourEmail(event.target.value);
        setYourEmailError(!event.target.value ? requiredFieldMessage : "");
    };
    const yourMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setYourMessage(event.target.value);
        setYourMessageError(!event.target.value ? requiredFieldMessage : "");
    };

    const shareButtonClickHandler = async () => {
        if (checkForErrors()) {
            return;
        }

        // const isReCaptchaValid = await validateReCaptcha({});
        const isReCaptchaValid = await validateReCaptcha({
            location: "ShareProduct",
            recaptchaRef,
        });
        if (!isReCaptchaValid) {
            return;
        }


        setInProgress(true);

        shareProduct({
            product,
            productDetailPath: productInfo.productDetailPath,
            friendsName: recipientName,
            friendsEmailAddress: recipientEmail.trim(),
            yourName,
            yourEmailAddress: yourEmail.trim(),
            yourMessage,
            onSuccess: () => {
                setshowEmailSentModal(true);
            },
            onComplete(resultProps: any) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.();
                }
            },
        });
    };

    return (
        <>
            <Link {...styles.link} onClick={shareLinkClickHandler} data-test-selector="productShareLink">
                <Icon size={18} src={ShareIcon} color="primary" />
            </Link>
            <Modal
                {...styles.modal}
                headline={translate("Email this Product")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                {
                    showEmailSentModal ?
                        <>
                            <Typography {...styles.shareText}>{translate(`You successfully emailed ${product?.detail?.name} to ${recipientEmail}`)}</Typography>
                        </>
                        :
                        <>
                            <Typography {...styles.requiredFields}>*{translate("Required Fields")}</Typography>
                            <GridContainer {...styles.container} data-test-selector="productShareModal">
                                <GridItem {...styles.yourEmailGridItem}>
                                    <TextField
                                        label={translate("To*")}
                                        value={recipientEmail}
                                        error={recipientEmailError}
                                        onChange={recipientEmailChangeHandler}
                                        data-test-selector="productShareRecipientEmail"
                                        {...styles.recipientEmailTextField}
                                    />
                                </GridItem>

                                <GridItem {...styles.yourEmailGridItem}>
                                    <TextField
                                        label={translate("From*")}
                                        value={yourEmail}
                                        error={yourEmailError}
                                        onChange={yourEmailChangeHandler}
                                        data-test-selector="productShareYourEmail"
                                        {...styles.yourEmailTextField}
                                    />
                                </GridItem>
                                <GridItem {...styles.yourEmailGridItem}>
                                    <TextArea
                                        label={translate("Message \n (optional)")}
                                        value={yourMessage}
                                        error={yourMessageError}
                                        onChange={yourMessageChangeHandler}
                                        data-test-selector="productShareYourMessage"
                                        {...styles.yourMessageTextArea}
                                    />
                                </GridItem>
                                <GridItem {...styles.reCaptchaGridItem}>
                                    <ReCaptcha recaptchaRef={recaptchaRef} location="ShareProduct" />
                                </GridItem>
                            </GridContainer>
                            <StyledWrapper {...styles.buttonsWrapper}>
                                <Button
                                    {...styles.cancelButton}
                                    onClick={modalCloseHandler}
                                    data-test-selector="productShareCancel"
                                >
                                    {translate("Cancel")}
                                </Button>
                                <Button
                                    {...styles.shareButton}
                                    onClick={shareButtonClickHandler}
                                    data-test-selector="productShareSubmit"
                                    disabled={inProgress}
                                >
                                    {translate("Send Email")}
                                </Button>
                            </StyledWrapper>
                        </>
                }

            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProduct(ADIProductShareLink));
